import React, { memo } from 'react';
import formStyles from '../../../form/Form.module.css';
import Input from '../../../form/Input';

const ImagensTabPanel = ({ module, dados }) => {
    const { preview, produtoImagens } = module.state;
    const { onFileChange } = module.actions;

    const API_URL = process.env.REACT_APP_API;

    return (
        <div className={formStyles.tab_container}>
            <div className={formStyles.preview_bandeira}>
                <h4>Imagens do Produto</h4>
            </div>

            <div className={formStyles.preview_bandeira}>
                <Input text="Fotos do Produto" type="file" name="images" handleOnChange={onFileChange} inputWidth="400px" multiple={true} accept=".jpg, .jpeg, .png" />
            </div>

            <div className={formStyles.preview_bandeira} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {/* 1. Previews de novos arquivos selecionados */}
                {preview.length > 0 &&
                    preview.map((image, index) => (
                        <img
                            key={`preview-${index}`}
                            src={URL.createObjectURL(image)}
                            alt="Preview novo"
                            className={formStyles.img_preview} // Use sua classe ou style fixo
                            style={{ border: '1px solid #000', width: '60px', height: '80px', objectFit: 'cover' }}
                        />
                    ))}

                {/* 2. Imagens que já existem no Banco de Dados */}
                {preview.length === 0 &&
                    produtoImagens.map((imagem, index) => (
                        <img
                            key={imagem.uuid || index}
                            src={`${API_URL}/imagens/${imagem.descricao}`}
                            alt={`Imagem ${index + 1}`}
                            title={`${imagem.posicao}: ${imagem.descricao}`}
                            loading="lazy"
                            style={{ border: '1px solid #000', margin: '2px', width: '60px', height: '80px', objectFit: 'cover' }}
                        />
                    ))}
            </div>
        </div>
    );
};

export default memo(ImagensTabPanel);
